import { PriceAvailabilityRequestStatus } from '../../../../types/PriceAvailabilityRequestsStatus';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface CreatePriceAvailabilityRequestParams {
    offerId: string;
    customerId: string;
    supplierId: string;
    requestNumber?: string;
    status?: PriceAvailabilityRequestStatus;
}

export interface PriceAvailabilityRequest {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    offerId: string;
    customerId: string;
    supplierId: string;
    requestNumber?: string;
    status: PriceAvailabilityRequestStatus;
}

export const createPriceAvailabilityRequest = async (
    params: CreatePriceAvailabilityRequestParams
): Promise<PriceAvailabilityRequest> => {
    const response = await authorizedAxiosInstance.post('/v1/price-availability-requests', params);
    return response.data;
};

export const getPriceAvailabilityRequestByOfferId = async (
    offerId: string
): Promise<PriceAvailabilityRequest | null> => {
    try {
        const response = await authorizedAxiosInstance.get(`/v1/price-availability-requests/offer/${offerId}`);
        return response.data;
    } catch (error: any) {
        // Return null if no PAI exists (404)
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};
